export default __webpack_public_path__ + "static/media/finance1.ad012167.mp4";